// §2.6 (rev 2.3) the Meter's state: Target met, On pace, Behind pace (pace known) or Under target. No imports (tests run it in node).
export function meterState(value, target, pace) {
  if (target == null || !(target > 0)) return null;
  if (value >= target) return { tone: 'ok', label: 'Target met', under: false };
  if (pace != null) return value >= pace * target ? { tone: 'ok', label: 'On pace', under: false } : { tone: 'warn', label: 'Behind pace', under: true };
  return { tone: 'warn', label: 'Under target', under: true };
}

